import { localize } from "render/context/InternationalizationContext";

export const Trans = {
  Scan: localize<{ scanNum: number }>({
    en_GB: ({ scanNum }) => <>Scan {scanNum}</>,
    sv_SE: ({ scanNum }) => <>Scan {scanNum}</>,
  }),
};
